import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { ModeFormValues } from "src/models/Mode.model";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";

type Props = {
  formikProps: FormikProps<ModeFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const Mode = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Mode" : "Update Mode"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="modeName"
            required
            value={values.modeName}
            onChange={(e) => {
              setFieldValue("modeName", e.target.value);
            }}
            label=" Mode Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="modeCode"
            required
            value={values.modeCode}
            onChange={(e) => {
              setFieldValue("modeCode", e.target.value);
            }}
            label=" Mode Code"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="bookType"
            value={values.bookType}
            onChange={(e) => {
              setFieldValue("bookType", e.target.value);
            }}
            label="Book Type"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextArea
            name="description"
            value={values.description}
            onChange={(value) => {
              setFieldValue("description", value);
            }}
            label="Description"
            // onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default Mode;
